import React from 'react'
import Canonicals from 'containers/Canonicals'
import Nav from 'components/Nav'
import Footer from 'components/Footer'
import { MetaBreadcrumbs } from 'containers/Breadcrumbs'
import classNames from 'classnames'

export const Page = ({
  nav = true,
  footer = true,
  children,
  childrenProps = { className: 'pt-16 sm:pt-20 w-full flex flex-col' },
  navProps = {},
  className,
  ...props
}) => (
  <div className={classNames(className, 'min-h-screen h-full')} {...props}>
    {nav && <Nav {...navProps} />}

    <MetaBreadcrumbs />

    <Canonicals />

    <div {...childrenProps}>{children}</div>

    {footer && <Footer />}
  </div>
)

export default Page
